// Shared helpers for working with Nominatim (OpenStreetMap) requests.
// Browsers are not allowed to set the User-Agent header, so we only set it
// when running outside the browser (e.g. during SSR/CLI usage). For clients,
// we attach a contact email via the query string per Nominatim's usage policy.

const CONTACT_EMAIL =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    (import.meta.env.VITE_NOMINATIM_EMAIL ||
      import.meta.env.VITE_SUPPORT_EMAIL)) ||
  "hello@mudo.app";

/**
 * Returns safe headers for Nominatim fetch requests.
 * Browsers silently reject/throw on forbidden headers like User-Agent, so we only
 * attach it when window is undefined (i.e. Node / SSR contexts).
 */
export function getNominatimHeaders() {
  const headers = { "Accept-Language": "en" };
  if (typeof window === "undefined") {
    headers["User-Agent"] =
      "MudoCeramicsApp/1.0 (+https://mudo.app/contact)";
  }
  return headers;
}

/**
 * Ensures we always pass a contact email so requests comply with the Nominatim
 * fair use policy. Mutates the provided URL instance for convenience.
 */
export function applyNominatimContact(url) {
  if (url && url.searchParams && CONTACT_EMAIL) {
    url.searchParams.set("email", CONTACT_EMAIL);
  }
  return url;
}
